export const IVA_RATE = 0.08;
export const ISR_RATE = 0.0125;

const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// Menu prices already include IVA: extract it and optionally retain ISR over the base
export const computeInvoice = (gross, applyIsr) => {
  const g = round2(gross);
  const base = round2(g / (1 + IVA_RATE));
  const iva = round2(g - base);
  const isr = applyIsr ? round2(base * ISR_RATE) : 0;
  return { gross: g, base, iva, isr, total: round2(g - isr) };
};

export const money = (n) => `$${(Number(n) || 0).toFixed(2)}`;
